import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=73cc6f4c&scoped=true&"
import script from "./news-detail.vue?vue&type=script&lang=js&"
export * from "./news-detail.vue?vue&type=script&lang=js&"
import style0 from "./news-detail.vue?vue&type=style&index=0&id=73cc6f4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc6f4c",
  null
  
)

export default component.exports